<template>
  <Transition name="fade">
    <div
      v-if="isOpen"
      class="fixed inset-0 z-[10000] flex items-center justify-center bg-black/60 p-4 backdrop-blur-sm"
      @click.self="emit('close')"
    >
      <div
        class="relative w-full max-w-md rounded-[20px] border border-tertiary bg-secondary p-8 shadow-2xl"
      >
        <h2 class="mb-6 border-b border-tertiary pb-4 text-xl font-bold text-accent">
          Projekt überschreiben?
        </h2>
        <div class="mb-6">
          <p class="text-sm text-text-main">
            Du hast dieses Projekt bereits in deinem Namespace. Möchtest du es durch deine aktuellen
            Änderungen überschreiben?
          </p>
          <p class="mt-2 text-sm font-semibold text-accent">
            „{{ projectTitle }}"
          </p>
        </div>

        <div class="flex items-center justify-end gap-3">
          <button
            type="button"
            class="cursor-pointer rounded-standard bg-accent px-6 py-2 text-sm font-semibold text-text-main shadow-sm transition-all duration-150 hover:brightness-110"
            @click="submit"
          >
            Überschreiben
          </button>

          <button
            type="button"
            class="cursor-pointer rounded-standard border border-tertiary bg-primary px-6 py-2 text-sm font-semibold text-text-main transition-colors duration-150 hover:bg-primary/80"
            @click="emit('close')"
          >
            Abbrechen
          </button>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
defineProps<{
  isOpen: boolean
  projectTitle: string
}>()

const emit = defineEmits<{
  (event: 'close'): void
  (event: 'confirm'): void
}>()

function submit() {
  emit('confirm')
  emit('close')
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
